import { PageHeader } from "@/components/shared";
import { AgreementsRegister } from "@/components/documents/AgreementsRegister";

export default function MasterServiceAgreements() {
  return (
    <div data-testid="msa-page">
      <PageHeader title="Master Service Agreements" subtitle="Client MSAs with their amendments and renewals — the same records shown under each client's Agreements tab. NDAs / CDAs are under Client Onboarding; project POs and service agreements stay inside their projects." />
      <AgreementsRegister group="msa" testid="msa-register" />
    </div>
  );
}
